module.exports = __webpack_public_path__ + "static/media/me-7.0eea767b.svg";